import { Injectable, signal } from '@angular/core';

export interface MessageBody {
  text?: string;
  type: 'error' | 'message' | 'loader';
}

@Injectable({ providedIn: 'root' })
export class MessageDialogService {
  private readonly messageSignal = signal<MessageBody | null>(null);
  readonly message = this.messageSignal.asReadonly();

  public showMessage(message: MessageBody): void {
    this.messageSignal.set({ text: message.text, type: message.type });
  }

  public hideMessage(): void {
    this.messageSignal.set(null);
  }
}
